module.exports = __webpack_public_path__ + "img/bridge1.e70348ea.png";